import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id")({
  staticData: {
    title: "fleets.title",
  },
});
